import { ApiCartItem } from "@/app/lib/features/cart/cart.types";

export const formatPrice = (price: number | string): string => {
  if (typeof price === "string") {
    return price;
  }

  return new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: "TRY",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(price);
};

export const parsePrice = (
  priceString: string | number | undefined,
): number => {
  if (!priceString && priceString !== 0) return 0;

  // If it's already a number, return it
  if (typeof priceString === "number") {
    return priceString;
  }

  // Convert to string if it's not already
  const strPrice = String(priceString);

  const cleaned = strPrice.replace(/[^\d,.-]/g, "");

  // Virgül varsa tr-TR formatı: nokta binlik ayracı, virgül ondalık
  // ("1.399,98" → 1399.98). Virgül yoksa nokta ondalıktır ("699.99" → 699.99).
  // Eskiden koşulsuz replace(",", ".") yapılıyordu; "1.399,98" → "1.399.98"
  // → parseFloat → 1.399 gibi bin kat hatalı sonuç veriyordu.
  const normalized = cleaned.includes(",")
    ? cleaned.replace(/\./g, "").replace(",", ".")
    : cleaned;

  const parsed = parseFloat(normalized);

  return isNaN(parsed) ? 0 : parsed;
};

export const getCartItemName = (item: ApiCartItem): string => {
  return item.name || "Ürün";
};

export const getCartItemImage = (item: ApiCartItem): string => {
  return item.image || "";
};
